module.exports = __webpack_public_path__ + "static/media/edit-icon.887a3eb2.png";